import type { RequestOptions, GatewayOptions, FetchOptions } from './types'

export const BASE_DOMAIN = import.meta.env.VITE_APP_BASE_API || ''

/** 定义 Request Options 的默认值 */
export const defaultRequestOptions: RequestOptions = {
  // 环境
  env: 'pro',
  // 设置默认根地址
  baseURL: '',
  // 设置请求超时设置
  timeout: 30000,
  // 允许携带cookie
  withCredentials: true,
  // 业务id
  biz: '',
  // 获取公钥的地址
  pubKeyUrl: '//ms.jr.jd.com/gw/generic/getRSAPublicKey'
}

/** 定义网关转化数据默认值 */
export const defaultGatewayOptions: GatewayOptions = {
  // 成功的 code
  successCode: 0,
  // 未登录的code
  notLoginCode: 3,
  // 业务数据类型
  dataType: 'json',
  // 加密的默认数据
  encyptConfig: {
    flagKey: 'channelEncrypt',
    dataKey: 'bodyEncrypt'
  }
}

/** 接口传参配置 */
export const defaultFetchOptions: FetchOptions = {
  // 接口请求地址
  url: '',
  // 接口请求入参
  params: {},
  // 请求方式
  method: 'post',
  // 接口请求地址
  headers: {},
  // 是否需要加密
  encrypt: false,
  // 数据格式
  dataType: 'json',
  // 是否需要展示 loading
  loading: false
}
